export default "__VITE_ASSET__Buu0YL4F__"